import GrowthPercentageView from './GrowthPercentageView'

export default GrowthPercentageView
